import { utils } from 'frontendcommon-3'

const { softColor } = utils.ColorUtils
const brand01 = '#AF1685'
const brand02 = '#D488BF'

export const colors = {
  blackGrey: '#333333',
  darkGrey: '#737373',
  mediumGrey: '#B1B1B1',
  softGrey: '#E2E2E2',
  borderGrey: '#EEEEF0',
  lightGrey: '#FAFAFA',
  brand01,
  brand01Soft: softColor(brand01, 10),
  brand01Medium: softColor(brand01, 50),
  brand01Dark: softColor(brand01, 70),
  brand02,
  brand02Soft: softColor(brand02, 10),
  brand02Medium: softColor(brand02, 50),
  brand02Dark: softColor(brand02, 70),
  background: '#ffffff',
  sidebarBackground: '#fafafa',
  sidebarBorder: '#9c9c9c4D',
  sidebarFooterBorder: '#fafafa',
  navlinkColor: '#737373',
  navlinkHoverBackground: '#9C9C9C1A'
}

export const frontendcommonCss = `
:root {
  --fc-black-grey: ${colors.blackGrey};
  --fc-dark-grey: ${colors.darkGrey};
  --fc-medium-grey: ${colors.mediumGrey};
  --fc-soft-grey: ${colors.softGrey};
  --fc-border-grey: ${colors.borderGrey};
  --fc-light-grey: ${colors.lightGrey};
  --fc-brand-01: ${colors.brand01};
  --fc-brand-01-dark: ${colors.brand01Dark};
  --fc-brand-01-medium: ${colors.brand01Medium};
  --fc-brand-01-soft: ${colors.brand01Soft};
  --fc-brand-02: ${colors.brand02};
  --fc-brand-02-dark: ${colors.brand02Dark};
  --fc-brand-02-medium: ${colors.brand02Medium};
  --fc-brand-02-soft: ${colors.brand02Soft};
  --fc-brand-03: ${colors.brand03};
  --fc-brand-04: ${colors.brand04};
  --fc-brand-05: ${colors.brand05};
  --fc-brand-06: ${colors.brand06};
  --fc-background: ${colors.background};
  --fc-sidebar-background: ${colors.sidebarBackground};
  --fc-sidebar-border: ${colors.sidebarBorder};
  --fc-sidebar-footer-border: ${colors.sidebarFooterBorder};
  --fc-navlink-color: ${colors.navlinkColor};
  --fc-navlink-hover-backgound: ${colors.navlinkHoverBackground};
}
`

export const logo = 'https://farmacloud-profile.imgix.net/farmacloud-color.png'
export const logoSmall = 'https://farmacloud-profile.imgix.net/farmacloud-color-small.png'
export const logoColor = 'https://farmacloud-profile.imgix.net/farmacloud-color.png'
export const logoColorSmall = 'https://farmacloud-profile.imgix.net/farmacloud-color-small.png'
